// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "public/js/" + chunkId + "." + {"66":"7f987fe9","223":"1a8bb14c","548":"d4e3a70b","610":"d3378c6d","723":"c6c1025b","976":"598636b1"}[chunkId] + ".js";
};